import { render } from "./SectionChart.vue?vue&type=template&id=f98cebe2"
import script from "./SectionChart.vue?vue&type=script&lang=js"
export * from "./SectionChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__